package team.platforma.aicombo.activity.auth.component.fragment.password_restore

import aicombo.composeapp.generated.resources.Res
import aicombo.composeapp.generated.resources.arrow_left
import aicombo.composeapp.generated.resources.cross_m
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Text
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.produceState
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.intl.Locale
import androidx.compose.ui.text.intl.LocaleList
import androidx.compose.ui.unit.dp
//import androidx.core.bundle.Bundle
import org.jetbrains.compose.resources.painterResource
import org.koin.compose.koinInject
import team.platforma.aicombo.theme.colors.AppColors
import team.platforma.aicombo.theme.colors.getOutlinedTextColors
import team.platforma.aicombo.theme.typography.FontWeights
import team.platforma.aicombo.theme.typography.Typography
import team.platforma.auth_presentable.viewModel.ConfirmEmailViewModel
import team.platforma.extra_nav.component.fragment_component.Fragment
import team.platforma.extra_nav.utils.rememberKeyboardHeight
import team.platforma.multiplatform_material_extension.button.AppFilledButton
import team.platforma.multiplatform_material_extension.text_input.TextInput
import team.platforma.multiplatform_material_extension.ui.dialog.CommonDialog

@OptIn(ExperimentalMaterial3Api::class)
object EnterRestoreMailFragment : Fragment(
    route = "restore_enter_mail_fragment_route",
    fragmentBox = { componentNavigator, fragmentNavigator, paddingValues ->
        val keyboardHeight by rememberKeyboardHeight()
        val confirmCodeViewModel = koinInject<ConfirmEmailViewModel>()

        var email by remember { mutableStateOf("") }
        val validInput by produceState(initialValue = false, email) {
            value = checkValid(email)
        }

        var showCodeSendDialog by remember { mutableStateOf(false) }
        Box(modifier = Modifier.fillMaxSize()) {
            Scaffold(modifier = Modifier.fillMaxHeight().widthIn(max = 533.dp)
                .align(Alignment.Center),
                topBar = {
                    Row(
                        modifier = Modifier.fillMaxWidth()
                            .background(color = AppColors.bg.base().default)
                            .heightIn(min = 64.dp).clickable {
                                fragmentNavigator.navigateBack()
                            },
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Spacer(modifier = Modifier.width(16.dp))
                        Icon(
                            painter = painterResource(Res.drawable.arrow_left),
                            contentDescription = null,
                            tint = AppColors.text().default,
                            modifier = Modifier.size(24.dp)
                        )
                        Text("Восстановление пароля")
                        Spacer(modifier = Modifier.width(16.dp))
                    }
                }) { pV ->
                Box(modifier = Modifier.fillMaxSize().padding(pV)) {
                    Column(modifier = Modifier.fillMaxSize().padding(horizontal = 16.dp)) {
                        Text("Введите адрес электронной почты, который вы использовали при регистрации для восстановления пароля. Вы получите ссылку для сброса пароля.")

                        TextInput(
                            value = email,
                            onValueChange = {
                                email = it
                            },
                            modifier = Modifier.fillMaxWidth(),
                            label = {
                                Text(
                                    text = "Введите адрес электронной почты"
                                )
                            },
                            placeholder = {
                                Text(
                                    text = "Адрес электронной почты"
                                )
                            },
                            trailingIcon = {
                                if (email.isNotEmpty()) {
                                    IconButton(
                                        onClick = {
                                            email = ""
                                        }
                                    ) {
                                        Icon(
                                            painter = painterResource(Res.drawable.cross_m),
                                            contentDescription = null
                                        )
                                    }
                                }
                            },
                            keyboardOptions = KeyboardOptions.Default.copy(
                                keyboardType = KeyboardType.Email,
                                hintLocales = LocaleList(Locale("en")),
                                imeAction = ImeAction.Next
                            ),
                            colors = getOutlinedTextColors()
                        )

                        Spacer(modifier = Modifier.weight(1f))

                        AppFilledButton(
                            onClick = {
                                showCodeSendDialog = true
                            },
                            enabled = validInput,
                            modifier = Modifier.fillMaxWidth()
                        ) {
                            Text(
                                text = "Продолжить"
                            )
                        }

                        AppFilledButton(
                            onClick = {
                                //To restore password
                            },
                            enabled = true,
                            modifier = Modifier.fillMaxWidth(),
                            colors = ButtonDefaults.buttonColors().copy(
                                contentColor = AppColors.text().primary,
                                containerColor = Color.Transparent
                            )
                        ) {
                            Text(
                                text = "Если возникли вопросы - Напишите команде проекта"
                            )
                        }
                        Spacer(
                            modifier = Modifier.height(keyboardHeight)
                        )
                    }
                    if (showCodeSendDialog) {
                        CommonDialog(
                            onDismiss = { showCodeSendDialog = false }
                        ) {
                            Column(
                                horizontalAlignment = Alignment.CenterHorizontally,
                                modifier = Modifier.padding(24.dp)
                            ) {
                                Text(
                                    "Письмо отправлено", color = AppColors.text().default,
                                    style = Typography.text2xl(FontWeights.Medium)
                                )
                                Spacer(modifier = Modifier.height(24.dp))
                                Text(
                                    "Мы выслали Вам письмо с кодом для восстановления пароля",
                                    color = AppColors.text().default,
                                    style = Typography.textLg(FontWeights.Regular)
                                )
                                Spacer(modifier = Modifier.height(24.dp))
                                AppFilledButton(
                                    onClick = {

//                                        val dataBundle = Bundle()
//                                        dataBundle.putString("email_key", email)
                                        confirmCodeViewModel.clearViewModel()
                                        fragmentNavigator.navigate(
                                            EnterRestoreCodeFragment,

                                        )
                                    },
                                    enabled = true,
                                    modifier = Modifier.fillMaxWidth()
                                ) {
                                    Text(
                                        text = "Ok"
                                    )
                                }
                            }
                        }

                    }
                }
            }
        }

    }
)

private fun checkValid(email: String): Boolean {

    val enEmail = Regex("[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}\$")
    val ruEmail = Regex("[а-яА-Я0-9._%+-]+@[а-яА-Я0-9.-]+\\.[а-яА-Я]{2,}\$")
    return enEmail.matches(email) || ruEmail.matches(email)
}